module.exports = __webpack_public_path__ + "static/series_mx-60b042405d11b46c28c56923f6c8ed77.png";